import { applyEventClick } from "../eventSelection.js";

// Multi-select helpers for the Konva timeline. The currently selected event
// indices live on `eventGroupState[primary].selected`; this module is pure and
// just computes the next selection given a click + modifiers.

/**
 * Apply a region click to the current selection following the same modifier
 * conventions as the event list:
 *   - Ctrl/Cmd: toggle the clicked event in/out of the selection
 *   - Shift: select the range from the stable origin to the clicked event
 *   - no modifier: single-select the clicked event (and set it as the origin)
 *
 * @param {object} input
 * @param {number} input.eventIndex
 * @param {{ ctrlKey?: boolean, metaKey?: boolean, shiftKey?: boolean }} input.modifiers
 * @param {number[]} input.currentSelected
 * @param {number} [input.anchor]
 * @returns {{ selected: number[], anchor: number }}
 */
export function applyRegionClick({ eventIndex, modifiers, currentSelected, anchor }) {
    return applyEventClick({ eventIndex, modifiers, currentSelected, anchor });
}

/**
 * Dispatch the legacy custom event so the editor's virtual event list scrolls
 * to a clicked region (preserves the existing contract used by Editor.svelte).
 *
 * @param {number} eventIndex
 */
export function dispatchScrollToEvent(eventIndex) {
    if (typeof window === "undefined") return;
    try {
        window.dispatchEvent(
            new CustomEvent("scrollToVirtualListItem", { detail: { index: eventIndex } })
        );
    } catch {
        // CustomEvent unavailable - safe to ignore in non-browser contexts.
    }
}
